












import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '../../store';

@Component
export default class MapComponent extends Vue {
  @Prop(String) private readonly address!: string;

  get mapsrc() {
    const key = store.getters.google;
    return (
      'https://www.google.com/maps/embed/v1/place?key=' +
      key +
      '&q=' +
      this.address +
      '}'
    );
  }
}
